import { defineComponent as _defineComponent } from 'vue'
import { ref, PropType, onMounted, watch } from "vue"
import Nav from "@/components/layout/Nav.vue"
import CheckStep from "./shared/CheckStep.vue"
import Overview from "./ApplicationStepPage/Overview.vue"
import PersonalInfo from "./ApplicationStepPage/PersonalInfo.vue"
import ApplicationStepPage from "./ApplicationStepPage/ApplicationStepPage.vue"
import QuizIntro from "./ahead/QuizIntro.vue"
import TakeAssessmentModal from "./shared/TakeAssessmentModal.vue"
import NavItem from "./shared/NavItem.vue"
import useRouter from "@/router/useRouter"
import {
  ApplicationTrack,
  ApplicationFormSectionTypeEnum,
  Maybe,
  MeApplicantQueryQuery,
  MeApplicantQuery,
  Applicant,
} from "@/gql"
import Review from "./ApplicationStepPage/Review.vue"
import Help from "./ApplicationStepPage/Help.vue"
import { useQuery } from "@vue/apollo-composable"
import { APPLICANT_ID_KEY } from "@/components/apply/shared/constants"
import { useUtilities } from "@/hooks/useUtilities"
import { computed } from "vue"

type STEP = {
  name: string
  type: Maybe<ApplicationFormSectionTypeEnum> | undefined
  anchor: string
  externalFormUrl: Maybe<string> | undefined
  description: Maybe<string> | undefined
  timer: Maybe<number> | undefined
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationFlow',
  props: {
  applicationTrack: {
    type: Object as PropType<ApplicationTrack>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const completedSteps = ref<string[]>([])

const overviewButtonLabel = computed(() => {
  if (completedSteps.value.includes("personal-information")) {
    return "Continue Application"
  }

  return "Begin Application"
})

watch(
  () => completedSteps,
  (value) => {
    localStorage.setItem("COMPLETED_STEPS", JSON.stringify(value))
  }
)

const { isMobile } = useUtilities()

const { onResult } = useQuery<MeApplicantQueryQuery>(MeApplicantQuery, {
  applicantId: localStorage.getItem(APPLICANT_ID_KEY) as string,
})

const applicant = ref<Applicant | undefined>(undefined)

onResult((result) => {
  if (result.data) {
    applicant.value = result.data.meApplicant as Applicant
  }
})

const stages =
  props.applicationTrack?.applicationFormSections?.map((section) => ({
    name: section.title,
    type: section.sectionType,
    anchor: section.slug,
    externalFormUrl: section.externalFormUrl,
    description: section.description,
    timer: section.timer,
  })) || []

const helpStep = {
  name: "Help",
  type: undefined,
  anchor: "help",
  externalFormUrl: undefined,
  description: undefined,
  timer: undefined,
}

const activeStage = ref(stages[0])

const { router } = useRouter()

const navigateToStep = (stage?: STEP) => {
  if (!stage) return

  if (router.currentRoute.name && router.currentRoute.hash !== `#${stage.anchor}`) {
    router.push({ name: router.currentRoute.name, hash: `#${stage.anchor}` })
  }

  activeStage.value = stage
}

const onStartApplication = () => {
  navigateToStep(stages[1])
}

const onSavePersonalInfo = () => {
  navigateToStep(stages[2])
  if (!completedSteps.value.includes(stages[1].anchor)) {
    completedSteps.value = [...completedSteps.value, stages[1].anchor]
  }
}

const showQuizModal = ref(false)

const handleAssessmentModalClose = () => {
  showQuizModal.value = false
  completedSteps.value = [...completedSteps.value, activeStage.value?.anchor || ""]
  localStorage.setItem("COMPLETED_STEPS", JSON.stringify(completedSteps.value))
}

const hasCompletedQuiz = (anchor: string) => {
  return completedSteps.value.includes(anchor)
}

const onStartQuiz = (sectionId: string) => {
  const sectionTimestamp = localStorage.getItem(`QUIZ_SECTION_ID:${sectionId}`)

  if (sectionTimestamp) {
    // TODO: uncomment this when we have a timer

    // const timeElapsed = Date.now() - Number(sectionTimestamp)

    // const timeRemaining = (activeStage.value?.timer || 0) * 60 * 1000 - timeElapsed

    // if (timeRemaining > 0) {
    //   showQuizModal.value = true
    //   return
    // }
    showQuizModal.value = true
  } else {
    localStorage.setItem(`QUIZ_SECTION_ID:${sectionId}`, Date.now().toString())
    showQuizModal.value = true
  }
}

onMounted(() => {
  const cachedCompletedSteps = localStorage.getItem("COMPLETED_STEPS")
  cachedCompletedSteps && (completedSteps.value = JSON.parse(cachedCompletedSteps))

  if (!completedSteps.value.includes(stages[0].anchor)) {
    completedSteps.value = [...completedSteps.value, stages[0].anchor]
  }

  window.addEventListener("beforeunload", function (e) {
    e.preventDefault()
    e.returnValue = ""

    const confirmationMessage = "Are you sure you want to leave this page?"

    return confirmationMessage
  })
})

const logout = () => {
  localStorage.clear()
  window.location.href = "/"
}

return { __sfc: true,props, completedSteps, overviewButtonLabel, isMobile, onResult, applicant, stages, helpStep, activeStage, router, navigateToStep, onStartApplication, onSavePersonalInfo, showQuizModal, handleAssessmentModalClose, hasCompletedQuiz, onStartQuiz, logout, Nav, CheckStep, Overview, PersonalInfo, ApplicationStepPage, QuizIntro, TakeAssessmentModal, NavItem, Review, Help }
}

})